import { ArticleParagraph1, UIHeading2, UIText3, UIText1, ArrowDownS16 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './ProgramItem.css';
import cn from 'classnames';

import { HEADERS } from './constants';
import { useToggleState } from '@cian/react-utils';
import { IProgram } from '../../../../types/suburban';
import { MortgageProgramDescription } from '../../../MortgageProgramDescription';

export const ProgramItem: React.VFC<IProgram> = ({
  name,
  description,
  rate,
  creditLimitMillions,
  termYears,
  isUntilRate,
}) => {
  const { state: isOpen, toggle } = useToggleState(false);

  return (
    <div className={styles['item']}>
      <div className={styles['name']}>
        <UIHeading2 fontWeight="700">{name}</UIHeading2>
        <button onClick={toggle} className={styles['condition']}>
          <ArticleParagraph1 color="primary_100">Условия</ArticleParagraph1>
          <div className={cn(styles['arrow'], isOpen && styles['expanded'])}>
            <ArrowDownS16 color="primary_100" />
          </div>
        </button>
      </div>
      {isOpen && (
        <div className={styles['description']}>
          <MortgageProgramDescription description={description} />
        </div>
      )}
      <div>
        <div className={styles['header']}>
          {HEADERS.map((header, index) => (
            <UIText3 key={index} color="gray60_100">
              {header}
            </UIText3>
          ))}
        </div>
        <div className={styles['row']}>
          <UIText1>до {creditLimitMillions} млн ₽</UIText1>
          <UIText1>
            {isUntilRate ? 'до' : 'от'} {rate}%
          </UIText1>
          <UIText1>до {termYears} лет</UIText1>
        </div>
      </div>
    </div>
  );
};
